import { ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import * as sortBy from 'lodash/sortBy';
import { PromiseState, StatefulPromise } from '../../util/stateful-promise';
import { AirportService } from '../../airport/airport.service';
import { environment } from '../../../environments/environment';
var StateAirportsComponent = /** @class */ (function () {
    function StateAirportsComponent(_airportService, _route, _meta, _title, _errorHandler) {
        this._airportService = _airportService;
        this._route = _route;
        this._meta = _meta;
        this._title = _title;
        this._errorHandler = _errorHandler;
    }
    Object.defineProperty(StateAirportsComponent.prototype, "sortedAirports", {
        get: function () {
            if (this.airportsPromise.state !== PromiseState.Fulfilled) {
                return [];
            }
            return sortBy(this.airportsPromise.value, ['identifier']);
        },
        enumerable: true,
        configurable: true
    });
    StateAirportsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._route.data
            .subscribe(function (data) {
            _this.state = data.state;
            _this._updateMeta();
            _this.airportsPromise = new StatefulPromise(_this._airportService.getAirportsByState(_this.state.stateCode, true));
        }, function (error) {
            _this._errorHandler.handleError(error);
        });
    };
    StateAirportsComponent.prototype._updateMeta = function () {
        this._title.setTitle("Airports in " + this.state.name + " - " + environment.appName);
        this._meta.removeTag('name="description"');
    };
    return StateAirportsComponent;
}());
export { StateAirportsComponent };
